/**
 * Löst den Mandanten aus der Browser-Origin auf. Der Tenant-Fetch erfolgt bereits im
 * Healthcheck (Plugin 02); hier nur noch die Auswahl des aktuellen Mandanten, bevor
 * auth/hooks/openapi darauf zugreifen.
 */
export default defineNuxtPlugin(() => {
	const { resolveFromOrigin } = useTenant()
	resolveFromOrigin(window.location.origin)
})
